<template>
  <ion-phaser ref="ionphaser" v-bind:game.prop="game" v-bind:initialize.prop="initialize" />
</template>
<script>
import Phaser from "phaser";
export default {
  props: {
    Player: {
      id: ""
    },
    OnLevel2Finished: {
      type: Function
    }
  },
  data() {
    return {
      initialize: true,
      game: {
        type: Phaser.AUTO,
        width: 1080,
        height: 1920,
        scale: {
          mode: Phaser.Scale.WIDTH_CONTROLS_HEIGHT
        },
        physics: {
          default: "arcade",
          arcade: {
            //debug: true
            //gravity: { y: 150 }
          }
        },
        scene: {
          preload: function() {
            this.load.image(
              "title",
              require("../assets/2.中繼站1_2/中繼站1_BONUS TIME.png")
            );
            this.load.image(
              "bg",
              require("../assets/2.中繼站1_2/中繼站2_遊戲背景.png")
            );
            this.load.image(
              "mask",
              require("../assets/2.中繼站1_2/倒數開始_壓黑.png")
            );
            this.load.image(
              "intro",
              require("../assets/2.中繼站1_2/中繼站2_說明頁.png")
            );
            this.load.image(
              "close",
              require("../assets/2.中繼站1_2/中繼站1_X按鈕.png")
            );
            this.load.image(
              "score",
              require("../assets/2.中繼站1_2/中繼站2_數字時間.png")
            );
            this.load.image(
              "lime",
              require("../assets/2.中繼站1_2/中繼站2_檸檬.png")
            );
            this.load.image(
              "bomb",
              require("../assets/2.中繼站1_2/中繼站2_炸彈.png")
            );
            this.load.image(
              "timeup",
              require("../assets/2.中繼站1_2/中繼站1_時間到.png")
            );
            this.load.image(
              "result",
              require("../assets/2.中繼站1_2/中繼站2_計算成績.png")
            );
            this.load.image(
              "car_blue",
              require("../assets/2.中繼站1_2/車輛背影/back_B.png")
            );
            this.load.image(
              "car_red",
              require("../assets/2.中繼站1_2/車輛背影/back_R.png")
            );
            this.load.image(
              "car_yellow",
              require("../assets/2.中繼站1_2/車輛背影/back_Y.png")
            );
            this.load.image(
              "add_score",
              require("../assets/2.中繼站1_2/+1/+1_0010.png")
            );
            this.load.image(
              "sub_score",
              require("../assets/2.中繼站1_2/-1/-1_0010.png")
            );
            this.load.bitmapFont(
              "score_font",
              require("../assets/2.中繼站1_2/font/font.png"),
              "./font.fnt"
            );
          },
          init: function() {},
          create: function() {
            var delay = delaytime => {
              return new Promise(resolve => {
                this.tweens.add({
                  targets: [],
                  duration: delaytime,
                  onComplete: () => {
                    resolve("resolved");
                  }
                });
              });
            };
            var SetScore = score => {
              localScoreText.text =
                String(parseInt(score)).padStart(2, "0") + "s";
            };
            var carPositions = [250, 540, 830];
            var limeSpeed = { min: 500, max: 1000 };
            var bombSpeed = { min: 300, max: 500 };
            var startX = { min: 100, max: 980 };
            var nowCarIndex = 1;
            this.input.on("pointerdown", function(pointer) {
              if (!isGaming) return;
              var touchX = pointer.x;
              if (touchX <= 540) {
                nowCarIndex--;
                if (nowCarIndex < 0) {
                  nowCarIndex = 0;
                }
              } else {
                nowCarIndex++;
                if (nowCarIndex > carPositions.length - 1) {
                  nowCarIndex = carPositions.length - 1;
                }
              }
              localCar.setPosition(carPositions[nowCarIndex], 1300);
            });
            var isGaming = false;
            this.registry.values.gametime = 30;
            this.OnGameStart = () => {
              this.close.setVisible(false);
              this.mask.setVisible(false);
              this.intro.setVisible(false);
              this.time.addEvent({
                delay: 100,
                callback: async () => {
                  while (this.registry.values.car == undefined) {
                    await delay(100);
                  }
                  this.scorebg.setVisible(true);
                  this.timetext.setVisible(true);
                  this.scoretext.setVisible(true);
                  this.car.setTexture(this.registry.values.car);
                  this.car.setVisible(true);
                  this.car.body.setEnable(true);
                  this.timeTimer.paused = false;
                  this.limegroup.getChildren().forEach(function(lime) {
                    lime.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        limeSpeed.min,
                        limeSpeed.max
                      )
                    );
                  }, this);
                  this.bombgroup.getChildren().forEach(function(bomb) {
                    bomb.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        bombSpeed.min,
                        bombSpeed.max
                      )
                    );
                  }, this);
                  isGaming = true;
                }
              });
            };
            this.add.image(0, 0, "bg").setOrigin(0);
            this.mask = this.add.image(540, 960, "mask").setOrigin(0.5);
            this.intro = this.add
              .image(540, 800, "intro")
              .setOrigin(0.5)
              .setInteractive()
              .on("pointerdown", this.OnGameStart);
            this.close = this.add
              .image(540, 1100, "close")
              .setOrigin(0.5)
              .setInteractive()
              .on("pointerdown", this.OnGameStart);

            this.car = this.physics.add
              .image(540, 1300, "car_blue")
              .setOrigin(0.5, 0)
              .setImmovable()
              .setVisible(false);
            this.car.body.setEnable(false);
            this.car.body.setSize(200, 400);
            var localCar = this.car;
            var score = 0;
            this.timeTimer = this.time.addEvent({
              delay: 1000,
              callback: () => {
                this.registry.values.gametime--;
                this.timetext.text = String(
                  this.registry.values.gametime
                ).padStart(2, "0");
                if (this.registry.values.gametime <= 0) {
                  isGaming = false;
                  this.limegroup.getChildren().forEach(function(lime) {
                    lime.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    lime.setVelocityY(0);
                  }, this);
                  this.bombgroup.getChildren().forEach(function(bomb) {
                    bomb.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    bomb.setVelocityY(0);
                  }, this);
                  this.time.addEvent({
                    delay: 1000,
                    callback: () => {
                      this.resultBigScoretext.text = this.resultScoreText2.text = this.resultScoreText.text = String(
                        score
                      );
                      this.resultBigScoretext.text += "s";
                      this.showTimeup.play();
                      this.scorebg.setVisible(false);
                      this.timetext.setVisible(false);
                      this.scoretext.setVisible(false);
                      this.showResult.play();
                      this.showResultText.play();
                      this.time.addEvent({
                        delay: 2500,
                        callback: () => {
                          this.registry.values.onGameEnded(score);
                        }
                      });
                    }
                  });
                }
              },
              repeat: this.registry.values.gametime - 1,
              paused: true
            });
            this.limegroup = this.physics.add.group({
              defaultKey: "lime"
            });
            this.bombgroup = this.physics.add.group({
              defaultKey: "bomb"
            });

            this.physics.world.bounds.setTo(-540, -1000, 2160, 3220);
            for (var i = 0; i < 5; i++) {
              var addscore = this.add
                .image(this.car.x, 1200, "add_score")
                .setAlpha(0);
              var subscore = this.add
                .image(this.car.x, 1200, "sub_score")
                .setAlpha(0);
              var add_score_show = this.tweens.add({
                targets: addscore,
                paused: true,
                props: {
                  alpha: {
                    value: { from: 0, to: 1 },
                    duration: 300,
                    ease: "Linear",
                    yoyo: true
                  },
                  y: { value: "-=100", duration: 300, ease: "Cubic" }
                },
                ease: "Linear",
                repeat: 0
              });
              var sub_score_show = this.tweens.add({
                targets: subscore,
                paused: true,
                props: {
                  alpha: {
                    value: { from: 0, to: 1 },
                    duration: 300,
                    ease: "Linear",
                    yoyo: true
                  },
                  y: { value: "-=100", duration: 300, ease: "Cubic" }
                },
                repeat: 0
              });
              var lime = this.limegroup.create(
                Phaser.Math.RND.integerInRange(startX.min, startX.max),
                -500
              );
              lime.body.setCollideWorldBounds(true);
              lime.body.onWorldBounds = true;
              lime.body.world.on(
                "worldbounds",
                function(body) {
                  if (body.gameObject === this) {
                    this.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    this.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        limeSpeed.min,
                        limeSpeed.max
                      )
                    );
                  }
                },
                lime
              );
              this.physics.add.collider(
                lime,
                this.car,
                (function() {
                  var add = add_score_show;
                  return function(obj, obj2) {
                    if (!isGaming) return;
                    score++;
                    if (score > 99) score = 99;
                    SetScore(score);
                    if (!add.isPlaying()) {
                      add.targets[0].setPosition(obj.x, obj2.y);
                      add.play();
                    }
                    obj.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    obj.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        limeSpeed.min,
                        limeSpeed.max
                      )
                    );
                  };
                })()
              );
              if (i > 2) continue;
              var bomb = this.bombgroup.create(
                Phaser.Math.RND.integerInRange(startX.min, startX.max),
                -500
              );
              bomb.body.setCollideWorldBounds(true);
              bomb.body.onWorldBounds = true;
              bomb.body.world.on(
                "worldbounds",
                function(body) {
                  if (body.gameObject === this) {
                    this.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    this.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        bombSpeed.min,
                        bombSpeed.max
                      )
                    );
                  }
                },
                bomb
              );
              this.physics.add.collider(
                bomb,
                this.car,
                (function() {
                  var sub = sub_score_show;
                  return function(obj, obj2) {
                    if (!isGaming) return;
                    if (score > 0) score--;
                    SetScore(score);
                    if (!sub.isPlaying()) {
                      sub.targets[0].setPosition(obj.x, obj2.y);
                      sub.play();
                    }
                    obj.setPosition(
                      Phaser.Math.RND.integerInRange(startX.min, startX.max),
                      -500
                    );
                    obj.setVelocityY(
                      Phaser.Math.RND.integerInRange(
                        bombSpeed.min,
                        bombSpeed.max
                      )
                    );
                  };
                })()
              );
            }

            this.title = this.add
              .image(305, 0, "title")
              .setOrigin(0, 0)
              .setVisible(false);
            this.scorebg = this.add
              .image(0, 300, "score")
              .setOrigin(0, 0)
              .setVisible(false);
            this.scoretext = this.add
              .bitmapText(
                170,
                390,
                "score_font",
                "00s" /*{
                fontSize: "150px",
                align: "left",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0)
              .setVisible(false);
            var localScoreText = this.scoretext;
            this.timetext = this.add
              .bitmapText(
                690,
                390,
                "score_font",
                this.registry.values
                  .gametime /*{
                fontSize: "150px",
                align: "center",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0)
              .setVisible(false);

            this.timeup = this.add.image(550, 250, "timeup").setOrigin(0.5);
            this.timeup.scale = 0;
            this.showTimeup = this.tweens.add({
              targets: this.timeup,
              scale: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
            var result = this.add.image(540, 800, "result").setOrigin(0.5);
            result.scale = 0;
            this.resultScoreText = this.add
              .text(515, 678, "0", {
                fontSize: "55px",
                align: "left",
                color: "#000"
              })
              .setOrigin(0.5)
              .setAlpha(0);
            this.resultScoreText2 = this.add
              .text(570, 610, "0", {
                fontSize: "55px",
                align: "left",
                color: "#000"
              })
              .setOrigin(0.5)
              .setAlpha(0);
            this.resultBigScoretext = this.add
              .bitmapText(
                525,
                880,
                "score_font",
                "0S" /*{
                fontSize: "200px",
                align: "center",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0.5)
              .setAlpha(0);
            this.showResult = this.tweens.add({
              targets: result,
              scale: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
            this.showResultText = this.tweens.add({
              targets: [
                this.resultScoreText,
                this.resultScoreText2,
                this.resultBigScoretext
              ],
              alpha: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              delay: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
          },
          update: function() {}
        }
      }
    };
  },
  computed: {
    data: function() {
      return this.$refs.ionphaser.game.instance.registry.values;
    }
  },
  async mounted() {
    while (this.$refs.ionphaser.game.instance == undefined) {
      await this.Delay(100);
    }
    switch (this.Player.carType) {
      case 1:
        this.data.car = "car_yellow";
        break;
      case 2:
        this.data.car = "car_blue";
        break;
      case 3:
        this.data.car = "car_red";
        break;
    }

    this.data.onGameEnded = score => {
      if (this.OnLevel2Finished) {
        this.OnLevel2Finished(parseInt(score));
      }
    };
  },
  methods: {
    Delay(interval) {
      return new Promise(resolve => {
        setTimeout(resolve, interval);
      });
    }
  }
};
</script>
